import { render } from "./MicrosoftLogin.vue?vue&type=template&id=68cce333&scoped=true"
import script from "./MicrosoftLogin.vue?vue&type=script&lang=js"
export * from "./MicrosoftLogin.vue?vue&type=script&lang=js"

import "./MicrosoftLogin.vue?vue&type=style&index=0&id=68cce333&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cce333"]])

export default __exports__